<template>
  <el-tooltip el-tooltip :disabled="isDisabeldTop"  :content="isDisabeldTop ? '' : 'No Permission'" placement="bottom">
    <div class="header-select" :style="isDisabeldTop ? '' : 'cursor: not-allowed'">
      <div
        class="header-select-value"
        :style="{'color' : '#000'}"

        @click="handlerClickName" ref="selectValue">{{selectValue}}</div>
      <div class="header-select-list" v-show="showList" ref="selectList">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="item"
            @click="handlerClickLi(item, index)"
            :style="{'color' : '#000'}"
          >{{item}}</li>
        </ul>
      </div>
    </div>
  </el-tooltip>
</template>
<script>

export default {
  name: 'headerSelect',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    colorList: {
      type: Array,
      default: () => ['#4c556c', '#d89800', '#008d7d', '#006da5', '#cf1322']
    },
    selectValue: {
      type: String,
      default: ''
    },
    disabeldSelete: {
      type: Boolean,
      default: false,
    },
    isDisabeldTop: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      name: '',
      showList: false,
      index: 99
    }
  },
  methods: {
    handlerClickLi(data, index) {
      this.showList = false
      this.name = data
      this.index = index
      this.$emit('changeHeaderSelect', data)
    },
    handlerClickName() {
      if(!this.isDisabeldTop) return
      this.showList = !this.showList
    },
    handlerDocument (res) {
      const parents = res.target?.parentNode?.parentNode
      if (this.$refs.selectValue == res.target) {
        return
      }
      if (this.$refs.selectList != parents) {
        this.showList = false
      }
    }
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handlerDocument)
  },
  created() {
    if (!this.name) {
      this.name = this.list.length ? this.list[0] : ''
      this.index = 0
    }
  },
  mounted() {
    document.body.addEventListener('click', this.handlerDocument)
  }
}
</script>
<style scoped lang="scss">
  .header-select{
    padding: 0 10px;
    width: 119px;
    height: 28px;
    display: inline-block;
    position: relative;
    background-color: #f0f2f5;
    font-size: 12px;
    cursor: pointer;
    border-radius: 14px;
    font-weight: 500;

    .header-select-list{
      position: absolute;
      z-index: 1000;
      margin-top: 4px;
      width: 100%;
      left: 0;
      background-color: #fff;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
      max-height: 200px;
      overflow-y: auto;

      li{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-left: 12px;
        font-weight: 500;

        &:hover{
          background-color: #f6f7f9;
        }
      }

      &::-webkit-scrollbar{
        width: 4px;
        display: initial;
      }

      &::-webkit-scrollbar-thumb{
        border-radius: 2px;
        background   : #dadce1;
      }
    }
  }


  .header-select-value{
    height: 28px;
    border-radius: 2px;
    line-height: 28px;
    background-image: url("../../assets/img/tp-header/down2.svg");
    background-repeat: no-repeat;
    background-size: 16px;
    background-position: center right;
    font-weight: bold;
    font-weight: bold;
    font-size: 14px;
  }
</style>
